export default __webpack_public_path__ + "static/media/p2p-cat.03321e4c.webp";